import { Service, signal } from '@angular/core';

/**
 * Translation key of the heading shown above the routed view, or `null` when the
 * current route asks for no heading.
 *
 * The key is not resolved here: `TranslatedTitleStrategy` already walks the route
 * tree for the browser tab, and pushes the same result in — one resolution, two
 * consumers. Legacy `PageService` had exactly this shape (`titleData` fed the
 * `app-page-title` component while `Title` fed the tab), which is why the split
 * lands here rather than in a second route-walking service.
 */
@Service()
export class PageTitleService {
  private readonly _titleKey = signal<string | null>(null);

  readonly titleKey = this._titleKey.asReadonly();

  /** Called by `TranslatedTitleStrategy` after every navigation. */
  setTitleKey(key: string | null): void {
    this._titleKey.set(key);
  }
}
